export const WEB_INTERACTIVES_URL = '/web-interactives/v1/cos-interactives';
export const LANDING_PAGES_URL = '/cospages/v2/landing-pages';